<template>
  <div class="nav">
    <div id="TogetherTop">
      <div class="navTop">
        <img v-if="!qudao" src="@/assets/lvluoxinshu.png" alt="">
        <img class="qudao" v-else :src="qudao.logo_url1" alt="">
        <div class="list">
          <!-- <span @click="desk" :class="topStateOne ? 'topMark' : 'top-module'">办公桌</span>
          <span @click="stu" :class="topStateTwo ? 'topMark' : 'top-module'">学生</span>
          <span @click="test" :class="topStateThree ? 'topMark' : 'top-module'">测评</span>
          <span @click="crisis" :class="topStateFour ? 'topMark' : 'top-module'">危机</span>
          <span @click="data" :class="topStateFive ? 'topMark' : 'top-module'">数据</span>
          <span @click="resource" :class="topStateSix ? 'topMark' : 'top-module'">资源</span>
          <span @click="my" :class="topStateSeven ? 'topMark' : 'top-module'">我的</span> -->
          <span v-for="(item, index) in navData" :key="index + 'a'" @click="desk(index)"
            :class="navNum === index ? 'topMark' : 'top-module'">
            <template v-if="roleID === 1">
              <template v-if="endNum !== 0">{{ item }}</template>
              <template v-else>
                <a-tooltip v-if="index === 4" class="showHide">
                  <template slot="title">服务到期，功能不可用</template>
                  {{ item }}
                </a-tooltip>
                <template v-else>{{ item }}</template>
              </template>
            </template>
            <template v-else-if="roleID === 2">
              <template v-if="index !== 1 && index !== 4">{{ item }}</template>
              <a-tooltip v-else class="showHide">
                <template slot="title">仅限超级管理员使用</template>
                {{ item }}
              </a-tooltip>
            </template>
            <template v-else>
              <template v-if="index !== 1 && index !== 3">{{ item }}</template>
              <a-tooltip v-else class="showHide">
                <template slot="title">仅限超级管理员使用</template>
                {{ item }}
              </a-tooltip>
            </template>
          </span>
          <span v-if="!qudao || (qudao && qudao.resource)" @click="desk(5)"
            :class="navNum === 5 ? 'topMark' : 'top-module'">资源</span>
          <span @click="desk(6)" :class="navNum === 6 ? 'topMark' : 'top-module'">我的</span>
          <span @click="desk(7)" :class="navNum === 7 ? 'topMark' : 'top-module'">国培计划</span>
          <!-- <span v-if="teacherAdmin.user_name === 'chaoguan'" @click="desk(6)" :class="navNum === 6 ? 'topMark' : 'top-module'">统计</span> -->
        </div>
      </div>
      <!-- <div class="flex top" @click="handleClick">
        <i class="icon icon"></i>&nbsp;
        <span style="cursor: pointer">拓展服务</span>
      </div>
      <div class="flex top-one">
        <i class="icon iconOne"></i><br>&nbsp;
        <span style="cursor: pointer">使用文档</span>
      </div> -->
      <div class="expire_box" v-if="endNum !== 1 && roleID === 1">
        <div v-if="endNum === 2" class="expire_item" @click="endHand">
          <img src="@/assets/sound_1.png" alt="">
          <span style="color: #FF9200;">您好~，服务即将到期，点击续费</span>
        </div>
        <div v-if="endNum === 0" class="expire_item" @click="endHand">
          <img src="@/assets/sound_2.png" alt="">
          <span style="color: #FF5219;">您好~，服务已过期，点击续费</span>
        </div>
      </div>
      <div class="flex top-two">
        <span style="padding-right: 20px;">{{ teacherAdmin.school_name }}</span>
        <img src="@/assets/TopPng1.png" alt="" style="margin-right: 10px">
        <!-- <i class="oicon iconTw" style="width: 16px; height: 16px"></i> -->
        <a-dropdown :trigger="['click']" placement="bottomRight">
          <a-icon type="down" style="width: 15px; height: 15px; cursor: pointer;" />
          <a-menu slot="overlay">
            <a-menu-item key="0" @click="logout">
              <span>退出登录</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import URL from '@/store/url'

export default {
  name: 'NavTop',
  data() {
    return {
      topStateOne: true,
      topStateTwo: false,
      topStateThree: false,
      topStateFour: false,
      topStateFive: false,
      topStateSix: false,
      topStateSeven: false,
      navData: ['办公桌', '学生', '测评', '危机', '数据中心'],
      nav: 0,
      roleID: null,
      teacherDqid: 0,
      teacherEndtime: null,
      cp: null,
      endNum: null,
      qudao: null
    }
  },
  computed: {
    ...mapState([
      'teacherAdmin',
      'navNum',
      'maxGrade',
      'minGrade',
      'endTimeBox',
      'allSurveys',
      'questionnairenTask',
      'schoolTaskList',
      'asyncFlag'
    ])
  },
  async mounted() {
    this.qudao = sessionStorage.getItem('qudao') ? JSON.parse(sessionStorage.getItem('qudao')) : null
    this.roleID = JSON.parse(sessionStorage.getItem('userInfo')).role_id
    this.cp = JSON.parse(sessionStorage.getItem('userInfo')).OPEN_TEACHER_CP
    this.endNum = JSON.parse(sessionStorage.getItem('userInfo')).end_num
    console.log(this.endTimeBox)
    if (this.roleID === 1 && this.endNum === 0 && this.endTimeBox) {
      await this.getAllSurveys()
      const openList = this.allSurveys.filter(item => item.RIGHT)
      if (openList.length) {
        await this.getOwnerScale()
      }
      if (this.cp) {
        await this.getTeacherScale()
        let infoList = JSON.parse(sessionStorage.getItem('userInfo'))
        infoList.OPEN_TEACHER_CP = 0
        sessionStorage.setItem('userInfo', JSON.stringify(infoList))
      }
      console.log(openList)
      console.log('弹窗')
      // await this.getTeacherScale()
      // await this.getOwnerScale()
    }
    if (this.roleID === 1 && this.cp) {
      let response = await this.getTeacherTestPlan() // 获取测评列表
      if (response.length) {
        this.teacherDqid = response[0].ID
        this.teacherEndtime = response[0].END_TIME
      }
    }
  },
  methods: {
    ...mapMutations([
      'setIsLogin',
      'setNavNum',
      'setEndTimeBox',
      'setActShow'
    ]),
    ...mapActions([
      'getTeacherTestPlan',
      'getOwnerScale',
      'getTeacherScale',
      'getAllSurveys',
      'asyncTeacherData'
    ]),
    async desk(index) {
      switch (index) {
        case 0:
          this.$router.push('/deskView')
          this.setNavNum(index)
          break
        case 1:
          if (this.roleID === 1) {
            this.$router.push('/studentList')
            this.setNavNum(index)
          }
          break
        case 2:
          this.$router.push('/evaluationList')
          this.setNavNum(index)
          break
        case 3:
          if (this.roleID === 1 || this.roleID === 2) {
            let oldSid = null
            let crisisScale = [993541, 993544, 993548, 995000, 995002]
            let task = []
            // 教育局任务
            if (this.questionnairenTask) {
              this.questionnairenTask.map(item => {
                if (item.CHILDREN && item.CHILDREN.length)
                  item.CHILDREN.map(value => {
                    if (value.DQ_ID && (new Date() > new Date(value.TASK_START_DATE.replace(/-/g, '/')))) { // 满足1:任务已分发、2:任务开始时间为已开始
                      if (value.SURVEY_LIST && value.SURVEY_LIST.length) { // 3:包含危机量表
                        let flag = value.SURVEY_LIST.filter(i => { return crisisScale.includes(i.SID) })
                        if (flag && flag.length) { // 包含危机表
                          // 4:满足以上3点的数据
                          oldSid = flag[0].SID
                          task.push({
                            qid: value.DQ_ID,
                            sid: flag[0].SID === 993548 ? 993548 : 993541,
                            start_time: value.TASK_START_DATE,
                            end_time: value.TASK_END_DATE
                          })
                        }
                      }
                    }
                  })
              })
            }
            // 单校任务
            if (this.schoolTaskList) {
              this.schoolTaskList.map(item => {
                if (item.type === 3 && (new Date() > new Date(item.start_time.replace(/-/g, '/')))) { // 满足1:群体分发、2:任务开始时间为已开始
                  if (item.scaleList && item.scaleList.length) { // 3:包含危机量表
                    let flag = item.scaleList.filter(i => { return crisisScale.includes(i.ID) })
                    if (flag && flag.length) { // 包含危机表
                      // 4:满足以上3点的数据
                      oldSid = flag[0].ID
                      task.push({
                        qid: item.qid,
                        sid: flag[0].ID === 993548 ? 993548 : 993541,
                        start_time: item.start_time,
                        end_time: item.end_time
                      })
                    }
                  }
                }
              })
            }
            task.sort((a, b) => b.qid - a.qid)
            if (task.length) { // 有任务
              if (oldSid !== 995002) {
                await this.asyncTeacherData({ SID: oldSid, DQ_ID: task[0].qid })
                if (!this.asyncFlag) {
                  this.$message.error('更新团体报告无效数据失败')
                }
              }
              window.open(`${URL.TO_CRISIS_NEW}?schoolId=${this.teacherAdmin.school_id}&teacherUid=${this.teacherAdmin.uid}&city=${this.teacherAdmin.city}&token=${this.teacherAdmin.tokenValue}&schoolName=${this.teacherAdmin.school_name}&minGrade=${this.minGrade}&maxGrade=${this.maxGrade}&roleId=${JSON.parse(sessionStorage.getItem('userInfo')).role_id}&jwt=${this.teacherAdmin.jwt}&dqid=${task[0].qid}&cp=${this.cp}&teacherDqid=${this.teacherDqid}&teacherEndtime=${this.teacherEndtime}&sid=${task[0].sid}&start_time=${task[0].start_time}&end_time=${task[0].end_time}&type=all`)
            } else {
              window.open(`${URL.TO_CRISIS_NEW}?schoolId=${this.teacherAdmin.school_id}&teacherUid=${this.teacherAdmin.uid}&city=${this.teacherAdmin.city}&token=${this.teacherAdmin.tokenValue}&schoolName=${this.teacherAdmin.school_name}&minGrade=${this.minGrade}&maxGrade=${this.maxGrade}&roleId=${JSON.parse(sessionStorage.getItem('userInfo')).role_id}&jwt=${this.teacherAdmin.jwt}&dqid=null&cp=${this.cp}&teacherDqid=${this.teacherDqid}&teacherEndtime=${this.teacherEndtime}&sid=null&start_time=null&end_time=null&type=all`)
            }
          }
          break
        case 4:
          if (this.roleID === 1 || this.roleID === 3) {
            this.$router.push('/dataCenter')
            this.setNavNum(index)
          }
          break
        case 5:
          if (this.endNum !== 0) {
            window.open(`${URL.TO_RESOURCE}`)
          }
          break
        case 6:
          this.$router.push('/userList')
          this.setNavNum(index)
          break
        case 7:
          this.setNavNum(7)
          this.$router.push('/guopeiStatistics')
          break
      }
    },
    logout() {
      this.setIsLogin(false)
      this.setActShow(false)
      this.setNavNum(0)
      sessionStorage.clear()
      this.$router.push({ path: '/' })
    },
    handleClick() {
      window.open('https://www.lvluoxinli.com/teacherPC/extend.html')
    },
    // 到期续费
    endHand() {
      this.setEndTimeBox(true)
      setTimeout(() => {
        this.setActShow(false)
      }, 50);
    }
  }
}
</script>

<style>
.nav {
  width: 100%;
  height: 60px;
  z-index: 1000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -1px 0px 0px rgba(232, 232, 232, 1);
  box-sizing: border-box;
  position: fixed;
}

.nav #TogetherTop {
  position: absolute;
  left: 50%;
  width: 1200px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
}

.nav #TogetherTop .navTop {
  height: 60px;
  display: flex;
  align-items: center;
}

.nav #TogetherTop .list {
  padding-left: 48px;
}

.nav #TogetherTop .flex {
  display: flex;
  align-items: center;
}

.nav #TogetherTop img {
  width: 32px;
  height: auto;
}

.nav #TogetherTop .navTop img {
  width: 143px;
  height: auto;
}
.nav #TogetherTop .navTop .qudao {
  width: 250px;
}

.nav #TogetherTop i {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  background-size: cover;
}

.nav #TogetherTop .icon {
  background-image: url('../assets/icon.png')
}

.nav #TogetherTop .iconOne {
  background-image: url('../assets/iconOne.png')
}

.nav #TogetherTop .iconTwo {
  background-image: url('../assets/iconTwo.png');
  cursor: pointer;
}

.nav #TogetherTop .top-module,
#TogetherTop .topMark {
  margin-left: 20px;
  margin-right: 20px;
  text-align: center;
  height: 100%;
  line-height: 60px;
  cursor: pointer;
}

.nav #TogetherTop .top-module {
  font-weight: 400;
  color: rgba(89, 89, 89, 1);
}

.nav #TogetherTop .topMark {
  font-weight: 600;
  color: rgba(38, 38, 38, 1);
}

.nav #TogetherTop .top {
  margin-left: 75px;
  color: #666666;
}

.nav #TogetherTop .top-one {
  margin-left: 30px;
  color: #666666;
}

.nav #TogetherTop .top-two {
  position: absolute;
  right: 0px;
  color: #666666;
}

.nav #TogetherTop .ant-input {
  border: none;
  width: 110px;
}

.nav #TogetherTop .bor-box {
  width: 1px;
  height: 14px;
  background-color: #D9D9D9;
}

.nav #TogetherTop .ant-btn {
  border: none;
  outline: none;
}

.nav #TogetherTop .ant-input {
  border-radius: 0px;
  border-bottom: 1px solid #999999;
}

.nav #TogetherTop .ant-input:focus {
  border: none;
  border-bottom: 1px solid #999999 !important;
  box-shadow: none;
}

.nav .showHide {
  color: #BFBFBF;
}

.ant-dropdown {
  padding-top: 20px;
}

.ant-dropdown-menu {
  padding: 0 0;
}

/* .ant-dropdown-menu-item{
  color: rgba(255,255,255,1);
  background-color: #51bf94;
}
.ant-dropdown-menu-item .ant-dropdown-menu-item-active{
  background-color: #51bf94;
} */
.nav .expire_box {
  margin-left: 80px;
}

.nav .expire_item {
  display: flex;
  cursor: pointer;
  align-items: center;
}

.nav .expire_item>img {
  width: 24px !important;
  height: auto !important;
  margin-right: 8px;
}</style>
 
